import React from 'react'
import { connectRefinementList } from 'react-instantsearch-dom'
import MiniCarousel from './MiniCarousel'
import { getInsuranceMiniCardsFromAlgoliaResults } from '../../domain/useCases/insurance/getInsuranceMiniCardsFromAlgoliaResults'
import { isNonEmptyArray } from '../../utils/checks'
const MiniCarouselConnected = (props) => {
  const {
    items,
    refine,
    pageType,
    itemsToIgnore,
    locationSlug,
    location,
    isUnitedStatesCount,
    primaryFocus,
    hideEmptyCarouselComponent
  } = props

  const cards = getInsuranceMiniCardsFromAlgoliaResults(
    items,
    itemsToIgnore,
    pageType,
    location,
    isUnitedStatesCount,
    primaryFocus
  )

  const miniCarouselProps = {
    ...props,
    cards,
    onCardClick: (card) => refine([card.title]),
    title: '',
    subTitle: '',
    hideEmptyCarouselComponent
  }

  return <MiniCarousel {...miniCarouselProps} />
}

export default connectRefinementList(MiniCarouselConnected)
